module.exports = __webpack_public_path__ + "img/int9.6169aebd.jpg";